import { RootState } from '../store';

export const getMyLoans = (store: RootState) => store.myLoans.loans;
export const getLoanRequestConfig = (store: RootState) =>
  store.myLoans.loanRequestConfig;
